import locale from "localization/en";

export const dryStockLubricantSalesColumn = [
  { key: "productCategory", text: locale.productCategory },
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "variant", text: locale.variant },
  { key: "unitPrice", text: locale.unitPrice, width: "150px" },
  { key: "quantitySold", text: locale.quantitySold },
  { key: "amount", text: locale.amount, width: "150px" },
  { key: "discounts", text: `${locale.discount}/${locale.premium}`, width: "150px" },
  { key: "vatExempt", text: locale.vatExempt, width: "150px" },
  { key: "finalAmount", text: locale.finalAmount, width: "150px" },
];

export const dryStockLPGSalesColumn = [
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "variant", text: locale.variant },
  { key: "unitPrice", text: locale.unitPrice },
  { key: "quantitySold", text: locale.quantitySold },
  { key: "amount", text: locale.amount },
  { key: "discounts", text: `${locale.discount}/${locale.premium}` },
  { key: "vatExempt", text: locale.vatExempt },
  { key: "finalAmount", text: locale.finalAmount },
];

export const dryStockDeliveriesColumn = [
  { key: "deliveryId", text: locale.deliveryId },
  { key: "dateAndTime", text: locale.dateAndTime },
  { key: "poReferenceNumber", text: locale.poReferenceNumber },
  { key: "plateNumber", text: locale.plateNumber },
  { key: "witnesses", text: locale.witnesses },
];
export const dryStockDeliveryProductsColumn = [
  { key: "deliveryId", text: locale.deliveryId },
  { key: "poReferenceNumber", text: locale.poReferenceNumber },
  { key: "itemCode", text: locale.itemCode },
  { key: "product", text: locale.product },
  { key: "variant", text: locale.variant },
  { key: "beforeReceiving", text: locale.beforeReceivingDS },
  { key: "quantityDelivered", text: locale.quantityDelivered },
  { key: "afterReceiving", text: locale.afterReceivingDS },
  { key: "variance", text: locale.variance, width: "200px" },
];

export const dryStockMovementColumn = [
  { key: "itemCode", text: locale.itemCode },
  {
    key: "product",
    text: locale.product,
  },
  {
    key: "variant",
    text: locale.variant,
  },
  {
    key: "type",
    text: locale.type,
  },
  {
    key: "actualBeginningInventory",
    text: locale.actualBeginningInventory,
    width: "200px",
  },
  {
    key: "delivery",
    text: locale.delivery,
  },
  {
    key: "sales",
    text: locale.sales,
  },
  {
    key: "returns",
    text: locale.returns,
  },
  {
    key: "expectedEndingInventory",
    text: locale.expectedEndingInventory,
  },
  {
    key: "actualEndingInventory",
    text: locale.actualEndingInventory,
    width: "200px",
  },
  {
    key: "variance",
    text: locale.variance,
  },
];
